import VueI18n from 'vue-i18n';

import { IBranch } from '@/types';

import getDayName from '@/utils/getDayName';
import { timeZone } from '@/utils/timeZone';

function _getBranchScheduleFormatted(
  branch: IBranch,
  timezoneOptions: ITimeZoneOptions,
  i18n: VueI18n,
  receive: Nullable<'work' | 'pickup' | 'delivery'> = 'pickup',
): string {
  const result = [];

  const schedule: WorkingTime[] =
    receive === 'pickup'
      ? branch.pickupSchedule
      : receive === 'delivery'
      ? branch.deliverySchedule
      : branch.workingTime;

  if (schedule.length === 0) {
    return '';
  }

  for (let day = 1; day <= 7; day++) {
    let line = getDayName(day <= 7 ? day - 1 : 1, i18n) + ': ';

    const workingTimeDay = schedule.find((time) => time.day === day);
    if (workingTimeDay) {
      const startTimeParts = workingTimeDay.startTime.split(':');
      const endTimeParts = workingTimeDay.endTime.split(':');

      if (
        startTimeParts &&
        startTimeParts.length >= 2 &&
        endTimeParts &&
        endTimeParts.length >= 2
      ) {
        if (endTimeParts[0] === '00' && endTimeParts[1] === '00') {
          endTimeParts[0] = '23';
          endTimeParts[1] = '59';
        }

        line +=
          timeZone(
            `${new Date().getFullYear()}-06-10T${startTimeParts[0].padStart(
              2,
              '0',
            )}:${startTimeParts[1].padStart(2, '0')}:00`,
            { type: 'timeShort', timezone: timezoneOptions },
          ) +
          ' – ' +
          timeZone(
            `${new Date().getFullYear()}-06-10T${endTimeParts[0].padStart(
              2,
              '0',
            )}:${endTimeParts[1].padStart(2, '0')}:00`,
            { type: 'timeShort', timezone: timezoneOptions },
          );
      }
    } else {
      line += i18n.t('global.branch.workingTime.dayOff').toString();
    }

    result.push(line);
  }

  return result.join('<br/>');
}

export default _getBranchScheduleFormatted;
